module.exports = __webpack_public_path__ + "img/20190808170000QQ截图20190808022631.9ecc7858.png";